if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}

/* WEAVESHOW collection Show More / Infinite Scroll — automatic, AJAX section rendering */
(function(){
  if(window.__WEAVESHOW_COLLECTION_LOAD_MORE_V2__) return;
  window.__WEAVESHOW_COLLECTION_LOAD_MORE_V2__=true;

  function initCollectionLoadMore(){
    document.querySelectorAll('[data-infinite-scrolling]').forEach(function(button){
      if(button.dataset.wsLoadMoreBound==='2') return;
      button.dataset.wsLoadMoreBound='2';
      var busy=false;

      function setState(loading){
        button.classList.toggle('loading',loading);
        button.setAttribute('aria-busy',loading?'true':'false');
      }

      async function loadNext(){
        if(busy || button.classList.contains('disabled')) return;
        var href=button.getAttribute('data-href') || button.getAttribute('href');
        if(!href || href==='javascript:void(0)') return;
        var grid=document.querySelector('#main-collection-product-grid');
        if(!grid) return;
        var sectionId=grid.getAttribute('data-id');
        if(!sectionId) return;

        busy=true;
        setState(true);
        try{
          var url=new URL(href,window.location.href);
          url.searchParams.set('sections',sectionId);
          var response=await fetch(url.toString(),{
            credentials:'same-origin',
            headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/json'}
          });
          if(!response.ok) throw new Error('Section request failed');
          var data=await response.json();
          var html=data[sectionId];
          if(!html) throw new Error('Collection section unavailable');

          var doc=new DOMParser().parseFromString(html,'text/html');
          var nextGrid=doc.querySelector('#main-collection-product-grid');
          if(!nextGrid) throw new Error('Product grid not found');

          var existingIds=new Set(Array.from(grid.children).map(function(item){
            return item.querySelector('[data-product-id]')?.getAttribute('data-product-id') || item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
          }));
          Array.from(nextGrid.children).forEach(function(item){
            var key=item.querySelector('[data-product-id]')?.getAttribute('data-product-id') || item.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
            if(!key || !existingIds.has(key)) grid.appendChild(item);
          });

          var currentStart=document.querySelector('[data-total-start]'), currentEnd=document.querySelector('[data-total-end]');
          var nextStart=doc.querySelector('[data-total-start]'), nextEnd=doc.querySelector('[data-total-end]');
          if(currentStart&&nextStart) currentStart.textContent=nextStart.textContent;
          if(currentEnd&&nextEnd) currentEnd.textContent=nextEnd.textContent;

          var currentProgress=document.querySelector('.pagination-total-item'), nextProgress=doc.querySelector('.pagination-total-item');
          if(currentProgress&&nextProgress) currentProgress.style.width=nextProgress.style.width;

          var nextButton=doc.querySelector('[data-infinite-scrolling]');
          if(nextButton && nextButton.getAttribute('data-href')){
            button.setAttribute('href',nextButton.getAttribute('href'));
            button.setAttribute('data-href',nextButton.getAttribute('data-href'));
            button.classList.remove('disabled');
            button.removeAttribute('aria-disabled');
          }else{
            button.setAttribute('href','javascript:void(0)');
            button.removeAttribute('data-href');
            button.classList.add('disabled');
            button.setAttribute('aria-disabled','true');
          }

          document.dispatchEvent(new CustomEvent('weaveshow:products-loaded'));
        }catch(error){
          console.warn('WEAVESHOW Show More:',error);
        }finally{
          busy=false;
          setState(false);
        }
      }

      button.addEventListener('click',function(event){
        event.preventDefault();
        loadNext();
      });
    });
  }

  function boot(){initCollectionLoadMore();}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  document.addEventListener('shopify:section:load',function(){setTimeout(initCollectionLoadMore,100);});
  document.addEventListener('weaveshow:products-loaded',function(){setTimeout(initCollectionLoadMore,100);});
})();
